import styled from 'styled-components';
export const Suggestions = styled.div `
  margin-bottom: var(--space-500);

  & > :not(:last-of-type) {
    margin-bottom: var(--space-300);
  }
`;
export const SellingPriceInputWrapper = styled.div `
  margin-bottom: var(--space-200);
`;
